import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'

export function getButtonIconSelectControlProps(props) {
  return {
    ...props,
    tooltipPlacement:
      props?.tooltipPlacement || FLOATING_ELEMENT_PLACEMENT.bottom,
  }
}
